import { render, staticRenderFns } from "./DashboardWrapper.vue?vue&type=template&id=76f8124a&scoped=true"
import script from "./DashboardWrapper.vue?vue&type=script&lang=js"
export * from "./DashboardWrapper.vue?vue&type=script&lang=js"
import style0 from "./DashboardWrapper.vue?vue&type=style&index=0&id=76f8124a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f8124a",
  null
  
)

export default component.exports